import {
  browserTracingIntegration,
  init,
  replayIntegration,
  setUser,
  vueIntegration,
} from '@sentry/vue'
import type { App } from 'vue'

export type SentrySettings = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  routerInstance?: any
  environment?: string
  release?: string
  debug?: boolean
  tracesSampleRate?: number
  replaysSessionSampleRate?: number
  replaysOnErrorSampleRate?: number
}

export function sentrySetUser(user: {
  id: string
  name: string
  email: string
}) {
  setUser({
    id: user.id,
    display_name: user.name,
    email: user.email,
  })
}

export function initSentry(
  app: App,
  dsn: string,
  settings: SentrySettings = {},
) {
  const integrations = [
    replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
    }),
    vueIntegration({
      tracingOptions: {
        trackComponents: true,
      },
    }),
  ]

  if (settings.routerInstance) {
    integrations.push(
      browserTracingIntegration({
        router: settings.routerInstance,
      }),
    )
  }

  init({
    app,
    dsn,
    integrations,
    environment: settings.environment || 'dev',
    release: settings.release,
    debug: settings.debug ?? false,
    tracesSampleRate: settings.tracesSampleRate ?? 1.0,
    tracePropagationTargets: [
      // backend api
      /https:\/\/api(?:\.[a-z]+)?\.abasupport\.abacus\.ch\/api/,
    ],
    replaysSessionSampleRate: settings.replaysSessionSampleRate ?? 0,
    replaysOnErrorSampleRate: settings.replaysOnErrorSampleRate ?? 0,
    ignoreErrors: [
      'Request failed with status code',
      'Request aborted',
      'Network Error',
      'TypeError: network error',
      'Failed to fetch',
      'ResizeObserver loop',
      'FILE_NOT_FOUND',
      'Error on update token',
      'Failed to refresh token',
      "Cannot read properties of null (reading 'append')", // usually from pdfjs-dist, temporary solution
    ],
  })
}
